export default class {
  constructor($uibModalInstance, syncValue, datapointName) {
    'ngInject';
    this.$uibModalInstance = $uibModalInstance;
    this.dtName = datapointName;
    this.syncValue = syncValue;
  }
  ok() {
    this.$uibModalInstance.close();
  }
  cancel() {
    this.$uibModalInstance.dismiss();
  }
}
